import { useParams } from '@reach/router'

export function useIsWithinReachRouter() {
  try {
    // Just chose an arbitrary hook to call because it fails when outside the reach router context
    // Which means we are not able to use Reach Router links
    useParams()
    return true
  } catch {
    return false
  }
}
